import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const RAG_CONFIG = {
  G: { label: 'On Track', bg: 'bg-[hsl(var(--rag-green-bg))]', text: 'text-[hsl(var(--rag-green))]', border: 'border-[hsl(var(--rag-green))]/20' },
  A: { label: 'Caution', bg: 'bg-[hsl(var(--rag-amber-bg))]', text: 'text-[hsl(var(--rag-amber))]', border: 'border-[hsl(var(--rag-amber))]/20' },
  R: { label: 'At Risk', bg: 'bg-[hsl(var(--rag-red-bg))]', text: 'text-[hsl(var(--rag-red))]', border: 'border-[hsl(var(--rag-red))]/20' },
  B: { label: 'Not Started', bg: 'bg-[hsl(var(--rag-blue-bg))]', text: 'text-[hsl(var(--rag-blue))]', border: 'border-[hsl(var(--rag-blue))]/20' },
};

const RAG_CYCLE = ['B', 'G', 'A', 'R'];

export function RagPill({ rag, projectId, onClick, readOnly = false }) {
  const config = RAG_CONFIG[rag] || RAG_CONFIG.B;

  const handleClick = () => {
    if (readOnly || !onClick) return;
    const idx = RAG_CYCLE.indexOf(rag);
    const next = RAG_CYCLE[(idx + 1) % RAG_CYCLE.length];
    onClick(next);
  };

  const pill = (
    <button
      type="button"
      onClick={handleClick}
      disabled={readOnly}
      data-testid={`rag-pill-${projectId}`}
      className={`inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full text-xs font-medium border transition-colors
        ${config.bg} ${config.text} ${config.border}
        ${!readOnly ? 'cursor-pointer hover:ring-1 hover:ring-[hsl(var(--ring))]/30' : 'cursor-default'}
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:ring-offset-2
      `}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${config.text.replace('text-', 'bg-')}`} />
      {config.label}
    </button>
  );

  if (readOnly) return pill;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>{pill}</TooltipTrigger>
        <TooltipContent side="top"><p className="text-xs">Click to cycle status</p></TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export { RAG_CONFIG, RAG_CYCLE };
